import { amazonEcsPlugin } from './plugin';

export default amazonEcsPlugin;